import VoucherCard from './VoucherCard'

export default VoucherCard
